'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

const ChartInstantApyError = () => {
  return <ErrorDataUnavailable minHeight="395px" />
}

export default memo(ChartInstantApyError)
